<template>
  <section class="card_style">
    <!-- skelton -->
    <div class="row" v-if="loading && $route.params.id">
      <div class="col-12 my-3">
        <Skeleton width="20%" class="my-2"></Skeleton>
      </div>
      <div class="col-12 my-3" v-for="i in 2" :key="i">
        <Skeleton width="20%" class="my-2"></Skeleton>
        <Skeleton width="70%" height="2rem" class="my-2"></Skeleton>
      </div>
      <div class="col-12 my-3">
        <Skeleton width="10%" height="10rem"></Skeleton>
      </div>
    </div>
    <!-- skelton -->

    <form @submit.prevent="addBanner()" v-else>
      <div class="main_header">
        <h4>{{ $t("Add Header") }}</h4>
      </div>

      <div class="row">
        <!-- Select type -->
        <div class="col-12">
          <div class="form-group">
            <label class="form-label" for="header_type">
              {{ $t("header_type") }}
            </label>
            <select
              name="type"
              class="form-control"
              id="header_title"
              v-model="header_type"
            >
              <option value="1">Home</option>
              <option value="2">Hotels</option>
              <option value="3">Flight</option>
              <option value="4">Package</option>
              <option value="5">About Us</option>
            </select>
          </div>
        </div>

        <!-- inputs -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="header_title_ar">
              {{ $t("header_title_ar") }}
            </label>
            <input
              type="text"
              class="form-control"
              id="header_title_ar"
              v-model="header_title_ar"
            />
          </div>
        </div>

        <!-- inputs -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="header_title_en">
              {{ $t("header_title_en") }}
            </label>
            <input
              type="text"
              class="form-control"
              id="header_title_en"
              v-model="header_title_en"
            />
          </div>
        </div>

        <!-- inputs -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="header_subtitle_ar">
              {{ $t("header_subtitle_ar") }}
            </label>
            <input
              type="text"
              class="form-control"
              id="header_subtitle_ar"
              v-model="header_subtitle_ar"
            />
          </div>
        </div>

        <!-- inputs -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="header_subtitle_en">
              {{ $t("header_subtitle_en") }}
            </label>
            <input
              type="text"
              class="form-control"
              id="header_subtitle_en"
              v-model="header_subtitle_en"
            />
          </div>
        </div>

        <!-- inputs -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="header_description_ar">
              {{ $t("header_description_ar") }}
            </label>
            <input
              type="text"
              class="form-control"
              id="header_description_ar"
              v-model="header_description_ar"
            />
          </div>
        </div>

        <!-- inputs -->
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="header_description_en">
              {{ $t("header_description_en") }}
            </label>
            <input
              type="text"
              class="form-control"
              id="header_description_en"
              v-model="header_description_en"
            />
          </div>
        </div>

        <!-- image upload -->
        <div class="col-12">
          <div class="form-group">
            <label class="form-label" for="banner_file">
              {{ $t("banner_images") }}
            </label>
            <input
              type="file"
              class="form-control"
              id="banner_file"
              multiple
              accept="image/png, image/gif, image/jpeg, image/jpg"
              @change="onFilesChange"
            />
          </div>

          <!-- Preview images -->
          <div class="images-list" v-if="images.length > 0">
            <div class="image-item" v-for="(img, index) in images" :key="index">
              <img :src="img.preview" class="entry_image" />
              <div class="form-group mx-2">
                <label class="form-label">alt</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="img.alt"
                  placeholder="Alt text"
                />
              </div>
              <button
                type="button"
                class="btn btn-danger btn-sm"
                @click="removeImage(img.id, index)"
              >
                X
              </button>
            </div>
          </div>

          <span class="input-errors" v-if="v$.images?.$error">
            {{ v$.images.$errors[0].$message }}
          </span>
        </div>

        <!-- submit button -->
        <div class="col-12">
          <button type="submit" class="btn PrimaryButton">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Skeleton from "primevue/skeleton";

export default {
  name: "addBanner",
  data() {
    return {
      v$: useVuelidate(),
      loading: true,
      header_title_ar: "",
      header_title_en: "",
      header_subtitle_ar: "",
      header_subtitle_en: "",
      header_description_ar: "",
      header_description_en: "",
      header_type: 0,
      banner_id: 25,
      images: [], // multiple images
    };
  },

  validations() {
    return {
      header_title_ar: { required },
      header_title_en: { required },
      header_subtitle_ar: { required },
      header_subtitle_en: { required },
      header_description_ar: { required },
      header_description_en: { required },
      images: { required },
    };
  },

  computed: {
    textFields() {
      return [
        {
          id: "header_title_ar",
          label: "header_title_ar",
          model: this.header_title_ar,
        },
        {
          id: "header_title_en",
          label: "header_title_en",
          model: this.header_title_en,
        },
        {
          id: "header_subtitle_ar",
          label: "header_subtitle_ar",
          model: this.header_subtitle_ar,
        },
        {
          id: "header_subtitle_en",
          label: "header_subtitle_en",
          model: this.header_subtitle_en,
        },
        {
          id: "header_description_ar",
          label: "header_description_ar",
          model: this.header_description_ar,
        },
        {
          id: "header_description_en",
          label: "header_description_en",
          model: this.header_description_en,
        },
      ];
    },
  },

  methods: {
    onFilesChange(event) {
      const files = Array.from(event.target.files);
      files.forEach((file) => {
        if (!file.type.match("image.*")) return;

        const reader = new FileReader();
        reader.onload = (e) => {
          this.images.push({
            file,
            preview: e.target.result,
            alt: "",
          });
        };
        reader.readAsDataURL(file);
      });
    },

    addBanner() {
      const formData = new FormData();
      formData.append("type", this.header_type);
      formData.append("header_id", this.banner_id ?? "");
      formData.append("title_ar", this.header_title_ar);
      formData.append("title_en", this.header_title_en);
      formData.append("sub_title_ar", this.header_subtitle_ar);
      formData.append("sub_title_en", this.header_subtitle_en);
      formData.append("description_ar", this.header_description_ar);
      formData.append("description_en", this.header_description_en);

      this.images.forEach((img, i) => {
        if (img.file) {
          formData.append(`images[${i}][image]`, img.file);
          formData.append(`images[${i}][alt]`, img.alt || "");
        }
      });

      axios
        .post(`/update_header`, formData)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            icon: "success",
          });
        })
        .catch((error) => {
          Swal.fire({
            text: error.response?.data?.message || "Error",
            icon: "error",
          });
        });
    },

    async showBanner() {
      if (!this.banner_id) {
        this.loading = false;
        return;
      }

      try {
        const { data } = await axios.post(`/show_header`, {
          header_id: this.banner_id,
        });

        const header = data.data;
        this.header_type = header.type;
        this.header_title_ar = header?.title[2]?.title || "";
        this.header_title_en = header?.title[1]?.title || "";
        this.header_subtitle_ar = header?.sub_title[2]?.sub_title || "";
        this.header_subtitle_en = header?.sub_title[1]?.sub_title || "";
        this.header_description_ar = header?.description[2]?.sub_title || "";
        this.header_description_en = header?.description[1]?.sub_title || "";

        this.images = Array.isArray(header.images)
          ? header.images.map((img) => ({
              file: null,
              preview: img.url || img.image,
              alt: img.alt || "",
              id: img.id,
            }))
          : [];

        this.loading = false;
      } catch (error) {
        console.error("Error fetching header:", error);
        Swal.fire({
          text: "فشل تحميل البيانات",
          icon: "error",
        });
        this.loading = false;
      }
    },
    removeImage(image_id, index) {
      axios
        .post(`/delete_header_image`, { header_image_id: image_id })
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            icon: "success",
          });
          this.images.splice(index, 1);
          this.showBanner();
        })
        .catch((error) => {
          Swal.fire({
            text: error.response?.data?.message || "Error",
            icon: "error",
          });
        });
    },
  },

  mounted() {
    this.showBanner();
  },

  components: {
    Skeleton,
  },
};
</script>

<style scoped>
.images-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;
}
.image-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
}
.entry_image {
  width: 150px;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
}
</style>
